import { render, staticRenderFns } from "./CreateEdit2.vue?vue&type=template&id=5c4362a1&"
import script from "./CreateEdit2.vue?vue&type=script&lang=js&"
export * from "./CreateEdit2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports